// extracted by mini-css-extract-plugin
export default {"ribbon":"LceStvcT4MHKbDZ5hh4H","danger":"KDmcjlBGpIuR4iVPjEWU","warning":"bJZUT4Xx1dpwXAhWcBEg","success":"ahWrYl71R2R9ifHYtYeX","primary":"gJLOF7KTQCvaokb90nql"};